import { ReactComponent as ChevronUp } from "assets/svg/chevron-up.svg";
import { useUser } from "contexts/UserContext";
import moment from "moment-timezone";
import getClasses from "utils/getClasses";
import styles from "./SessionItem.module.scss";
import NoteArea from "./NoteArea";

interface SessionItemProps {
  appointment: AppointmentMetaData;
  isExpanded?: boolean;
  onClick: () => void;
}

const SessionItem = ({
  appointment,
  isExpanded = false,
  onClick,
}: SessionItemProps) => {
  const { defaultUserTimezone } = useUser();

  const formattedDate = moment
    .tz(appointment.appointment_start, defaultUserTimezone)
    .format("dddd, MMM. D, YYYY - h:mm A z");

  return (
    <>
      <div className={styles["container"]} onClick={onClick}>
        <ChevronUp
          className={getClasses(isExpanded && styles["chevron-expanded"])}
        />
        <div className={styles["title-and-date"]}>
          <div className={styles["title"]}>
            {appointment.appointment_type_label}
          </div>
          <div className={styles["date"]}>{formattedDate}</div>
        </div>
        {/* <div className={styles["session-number"]}>#1</div> */}
      </div>
      {isExpanded && <NoteArea appoinmentId={appointment.appointment_id} />}
    </>
  );
};

export default SessionItem;
